import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import './DeleteDriverModal.css';
import AirModalTitlebar from "../../../../../common/components/AirModalTitlebar";
import AirButton from "../../../../../common/components/AirButton";

@inject('translationsStore')
@observer
export default class DeleteDriverModal extends Component {

  render() {
    const { translationsStore, visible, onCancel, onDelete } = this.props;

    return (
      <Fragment>
        <AirModalTitlebar
          visible={visible}
          cancelButton={<AirButton size="large" label={'No'} style={{ width: 240 }} />}
          okButton={<AirButton size="large" light label={translationsStore.translate('driversManager.deleteModal.okButtonText')} style={{ marginLeft: 20, width: 240 }} />}
          onCancel={onCancel}
          onOk={onDelete}
          title={`${translationsStore.translate('driversManager.deleteModal.title')} ?`}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--primary-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={560}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DeleteDriverModal/DeleteDriverModal.js